const workletNoop = () => {
  'worklet';
};

const noop = () => {};

export { noop, workletNoop };
//# sourceMappingURL=noop.js.map